/* globals flash */

/* eslint-disable class-methods-use-this */

class ErrorHandler {

  /**
   * Construct a new error handler.
   *
   * @param error
   */
  constructor(error) {
    this.status = error.response.status;
    this.message = error.response.data.message;
  }

  /**
   * Dispatch the error.
   *
   * @returns {*}
   */
  dispatch() {
    if (typeof this[`error${this.status}`] === 'function') {
      return this[`error${this.status}`]();
    }

    return console.warn(`No handler for error ${this.status}`);
  }

  /**
   * Handle an error 403.
   */
  error403() {
    flash({ title: 'Erreur 403', text: 'Cette action n\'est pas autorisée.', type: 'error' });
  }

  /**
   * Handle an error 404.
   */
  error404() {
    flash({ title: 'Erreur 404', text: 'La resource n\'existe pas.', type: 'error' });
  }

  /**
   * Handle an error 419.
   */
  error419() {
    flash({ title: 'Erreur 419', text: 'La session a expirée.', type: 'error', duration: 2000 });

    setTimeout(() => window.location.reload(), 2000);
  }

  /**
   * Handle an error 422.
   */
  error422() {
    flash({ title: 'Erreur', text: 'Les données fournies sont invalides.', type: 'error' });
  }

  /**
   * Handle an error 500.
   */
  error500() {
    flash({ title: 'Erreur 500', text: 'Une erreur est survenue.', type: 'error' });
  }

}

export default ErrorHandler;
